<div class="sp-margin__top sp-width__full sp-wrap">
  <div class="sp-row__align">
    <div
      class="sp-circle__xs sp-margin__right"
      [ngClass]="status_class"></div>
    <span class="sp-color__primary">
      {{ label | translate }}
    </span>
  </div>
  <hr class="sp-margin__top sp-width__full sp-stroke sp-stroke__dashed-dark" />
</div>
